import React from "react";

export default function KpiCard({ icon, title, value, deltaPct, isMoney }) {
  const pos = deltaPct >= 0;
  return (
    <div className="kpi" role="status" aria-label={title}>
      <div className="kpi-icon">{icon}</div>
      <div className="kpi-meta" style={{ flex: 1 }}>
        <div className="kpi-title">{title}</div>
        <div className="kpi-value">
          {isMoney ? `₹${Number(value).toLocaleString('en-IN', { maximumFractionDigits: 2 })}` : Number(value).toLocaleString()}
        </div>
      </div>
      <div className="kpi-delta" aria-label="change">
        {pos ? "↗" : "↘"} {Math.abs(deltaPct).toFixed(2)}%
      </div>
    </div>
  );
}
